import { render } from "./ViewerElement.vue?vue&type=template&id=64b15cb9&scoped=true"
import script from "./ViewerElement.vue?vue&type=script&lang=js"
export * from "./ViewerElement.vue?vue&type=script&lang=js"

import "./ViewerElement.vue?vue&type=style&index=0&id=64b15cb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b15cb9"]])

export default __exports__